import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {useEffect, useMemo, useState, useRef} from 'react'
import {
  fetchData,
  fetchFormData,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../../reusable'
import 'react-datepicker/dist/react-datepicker.css'
import {Link} from 'react-router-dom'
import {ToastContainer} from 'react-toastify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit, faEye, faEyeSlash, faKey, faTrash} from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2'
import Select from 'react-select'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { KTIcon, toAbsoluteUrl } from '../../../../_metronic/helpers'

const AddEditAdminPopup = (props: any) => {
    let t = Tr()

  // add / edit facility states
  const [adminId, setAdminId] = useState(props.adminId)
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [mobileNumber, setMobileNumber] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(Object)
  const [image, setImage] = useState()
  const [imageUrl, setImageUrl] = useState('')
  const [addloader, setaddLoader] = useState(false)
  const [disable, setDisable] = useState(false)
  const [passwordDisplay, setPasswordDisplay] = useState(false)
  const [selectedRole, setSelectedRole] = useState('') as any
  const [rolesList, setRolesList] = useState([])

  var tmp2 = sessionStorage.getItem('admin')
  // Step 2: Check if the item is not null
  if (tmp2) {
    // Step 3: Parse the JSON string
    var adminData = JSON.parse(tmp2)
    // Step 4: Access the adminId
    var mainAdminId = adminData.adminId
  }

  const saveSupportAdmin = async () => {
    setDisable(true)

    let param = new FormData()
    param.append('fullName', fullName)
    param.append('email', email)
    param.append('roleId', selectedRole)
    param.append('mobileNumber', mobileNumber)
    param.append('password', password)
    param.append('mainadminId', mainAdminId)
    param.append('countryCode', '1')
    param.append('createdBy', '1')

    if (image != null && image != undefined) {
      param.append('profilePicture', image)
    }
    if (props.adminId != '' && props.adminId != null && props.adminId > 0) {
      param.append('adminId', props.adminId)
    }

    var res = await fetchFormData('admin/addEditAdmin', param)

    if (res.status == '200') {
      toastsuccessmsg(res.message)
      setDisable(false)
      props.onHide()
    } else {
      setDisable(false)
      toasterrormsg(res.message)
    }
  }
  const validate = () => {
    const errotmp: any = {}
    let err = 0

    // Full Name: Required, only letters and spaces, max 50 chars
    const fullNameRegex = /^[A-Za-z\s]+$/
    if (!fullName || fullName.trim() === '') {
      errotmp['fullNameError'] = t('Full Name is required')
      err = 1
    } else if (!fullNameRegex.test(fullName.trim())) {
      errotmp['fullNameError'] = t('Full Name must contain only letters and spaces')
      err = 1
    } else if (fullName.trim().length > 50) {
      errotmp['fullNameError'] = t('Full Name is too long (max 50 characters)')
      err = 1
    }

    // Email: Required, must be valid and max 50 characters
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!email || email.trim() === '') {
      errotmp['emailError'] = t('Email is required')
      err = 1
    } else if (!emailRegex.test(email.trim())) {
      errotmp['emailError'] = t('Enter a valid email address')
      err = 1
    } else if (email.trim().length > 50) {
      errotmp['emailError'] = t('Email is too long (max 50 characters)')
      err = 1
    }

    // Mobile Number: Required, digits only, 10–15 characters
    const mobileRegex = /^[0-9]{10,15}$/
    if (!mobileNumber || mobileNumber.trim() === '') {
      errotmp['mobileNumberError'] = t('Mobile Number is required')
      err = 1
    } else if (!mobileRegex.test(mobileNumber.trim())) {
      errotmp['mobileNumberError'] = t('Enter a valid mobile number (10–15 digits)')
      err = 1
    }

    if (!selectedRole || selectedRole === '') {
      errotmp['roleError'] = t('Role Is Required')
      err = 1
    }

    if (props.adminId == '' || props.adminId == '0') {
      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
      if (!password || password.trim() === '') {
        errotmp['passwordError'] = t('Password is required')
        err = 1
      } else if (!passwordRegex.test(password.trim())) {
        errotmp['passwordError'] = t(
          'Password must be at least 8 characters and include letters and numbers'
        )
        err = 1
      }
    }

    // Image: Required
    if (!image && (!imageUrl || imageUrl === '')) {
      errotmp['imageError'] = t('Image is required')
      err = 1
    }

    setError(errotmp)
    if (err === 0) {
      saveSupportAdmin()
    }
  }

  const adminDetail = async () => {
    setaddLoader(true)
    var param = {
      adminId: props.adminId,
    }
    var res = await fetchData('admin/viewProfile', param)
    if (res.status == '200') {
      var data = res.data[0]

      setImageUrl(data.profilePicture)
      setFullName(data.fullName)
      setEmail(data.email)
      setMobileNumber(data.mobileNumber)
      setSelectedRole(data.roleId)

      setaddLoader(false)
    } else {
      setaddLoader(false)
      toasterrormsg(res.message)
    }
  }

  const rolesListApiCall = async () => {
    var param: any = {}
    var response: any = await fetchData('admin/viewrole', param)

    if (response.status == '200') {
      const data = response.data 
      let opt = [] as any
      data.map((item: any) => {

        if(item.roleId != '1'){
          opt.push({value: item.roleId, label: item.roleName})
        }
      })

      setRolesList(opt)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    if (props.adminId > 0) {
      adminDetail()
    }
    rolesListApiCall()
  }, [])

  // add / edit facility state end
  return (
    <Modal
      {...props}
      size='xl'
      aria-labelledby='contained-modal-title-hcenter'
      dialogClassName='maxwidth1000px'
      centered
      backdrop='static'
      keyboard={false}
    >
      <Modal.Header closeButton>
        <div className='d-flex align-items-center col-10'>
          <h4 className='fw-bold'>
            {adminId !== '' && adminId !== null && adminId > 0 ? t('Edit') : t('Add')}{' '}
            {t('Support Admin')}
          </h4>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div
          className='stepper stepper-links d-flex flex-column'
          id='kt_create_account_stepper'
          data-kt-stepper='true'
        >
          <div className='mx-auto mw-600px w-100 py-10' id='kt_create_account_form'>
            <div>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6 required'>
                  Profile Image
                </label>

                <div className='col-lg-8'>
                  <div className='image-input image-input-outline ' data-kt-image-input='true'>
                    <img
                      alt='images'
                      id='previewImage'
                      className='image-input-wrapper w-125px h-125px changeimg pointer'
                      src={
                        image
                          ? URL.createObjectURL(image)
                          : imageUrl === '' || imageUrl === null
                          ? toAbsoluteUrl('/media/default.jpg')
                          : imageUrl
                      }
                    />

                    <label
                      className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='change'
                      data-bs-toggle='tooltip'
                      title=''
                      data-bs-original-title='Change avatar'
                    >
                      <i className='fa fa-edit'></i>
                      <input
                        type='file'
                        name='image'
                        id='profileImage'
                        accept='.png, .jpg, .jpeg'
                        style={{display: 'none'}}
                        onChange={(e: any) => {
                          if (
                            e.target.files[0]['type'] != 'image/jpeg' &&
                            e.target.files[0]['type'] != 'image/jpg' &&
                            e.target.files[0]['type'] != 'image/png'
                          ) {
                            alert('Upload Only JPG, PNG Or PNG File')
                          } else if (e.target.files[0] != null && e.target.files[0] != undefined) {
                            setImage(e.target.files[0])
                          }
                        }}
                      />
                      <input type='hidden' name='avatar_remove' />
                    </label>
                  </div>

                  <div className='form-text' id='validimage'>
                    {t('Allowed file types: png, jpg, jpeg.')}
                  </div>
                  <label className='text-danger'>{error.imageError || ''}</label>
                </div>
              </div>
            </div>

            <div>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {t('Full Name')}
              </label>
              <input
                type='text'
                onChange={(e: any) => setFullName(e.target.value)}
                name='fullName'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder={t('Full Name')}
                value={fullName}
              ></input>
              <label className='text-danger'>{error.fullNameError || ''}</label>
            </div>
            <div>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>{t('Email')}</label>
              <input
                type='text'
                name='email'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder={t('Email')}
                onChange={(e: any) => setEmail(e.target.value)}
                value={email}
              ></input>
              <label className='text-danger'>{error.emailError || ''}</label>
            </div>
            <div>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {t('Mobile Number')}
              </label>
              <input
                type='text'
                name='mobileNumber'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder={t('Mobile Number')}
                onChange={(e: any) => setMobileNumber(e.target.value)}
                value={mobileNumber}
              ></input>
              <label className='text-danger'>{error.mobileNumberError || ''}</label>
            </div>

            <div>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                {t('Select Role')}
              </label>
              <Select
                name='selectRole'
                id='selectRole'
                placeholder={t('Select Role')}
                isSearchable={true}
                options={rolesList}
                value={rolesList.find((option: any) => option.value === selectedRole) || null}
                onChange={(e: any) => {
                  setSelectedRole(e.value)
                }}
                menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
                styles={{
                  menuPortal: (base) => ({...base, zIndex: 9999}), // Highest z-index
                  menu: (base) => ({...base, zIndex: 9999}),
                }}
              />
              <label className='text-danger'>{error.roleError || ''}</label>
            </div>
            {props.adminId == '' || props.adminId == '0' ? (
              <div className='fv-row mb-3 pt-1' style={{position: 'relative'}}>
                <label className='form-label fw-bolder text-dark fs-6 mb-2 required'>
                  {t('Password')}
                </label>
                <div style={{position: 'relative'}}>
                  <input
                    type={passwordDisplay == true ? 'text' : 'password'}
                    autoComplete='off'
                    placeholder={t('Password')}
                    className='form-control bg-transparent'
                    value={password}
                    onChange={(e: any) => setPassword(e.target.value)}
                  />
                  <span
                    className='cursor-pointer'
                    style={{position: 'absolute', top: '25%', right: '20px'}}
                    title={passwordDisplay == true ? 'Hide' : 'Show'}
                    onClick={() => setPasswordDisplay(!passwordDisplay)}
                  >
                    <FontAwesomeIcon icon={passwordDisplay == true ? faEyeSlash : faEye} />
                  </span>
                  <div className='fv-plugins-message-container invalid-feedback'></div>
                </div>
                <label className='text-danger'>{error.passwordError || ''}</label>
              </div>
            ) : (
              ''
            )}

            {/* action button start */}
            <div className={`d-flex pt-15 justify-content-center`}>
              <button
                type='button'
                className={`btn btn-lg btn-light-success me-3`}
                onClick={props.onHide}
              >
                {t('Cancel')}
              </button>

              <button
                type='button'
                disabled={disable}
                className={`btn btn-lg btn-success monthBtn me-3`}
                onClick={() => validate()}
              >
                {!disable && t('Save')}
                {disable && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {t('Please wait...')}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            {/* action button end */}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

//

 const ChangePasswordPopup = (props: any) => {
    let t = Tr()

    const [passwords, setPasswords] = useState({
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    })
    const [visibleFields, setVisibleFields] = useState({
      currentPassword: false,
      newPassword: false,
      confirmPassword: false,
    })
    const [error, setError] = useState<any>({})
    const [disable, setDisable] = useState(false)

    const toggleVisibility = (field: keyof typeof visibleFields) => {
      setVisibleFields((prev) => ({
        ...prev,
        [field]: !prev[field],
      }))
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const {name, value} = e.target
      setPasswords((prev) => ({
        ...prev,
        [name]: value,
      }))
    }

    const validate = () => {
      const errs: any = {}
      let hasError = false

      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/

      if (!passwords.currentPassword.trim()) {
        errs.currentPassword = t('Current password is required')
        hasError = true
      }

      if (!passwords.newPassword.trim()) {
        errs.newPassword = t('New password is required')
        hasError = true
      } else if (!passwordRegex.test(passwords.newPassword)) {
        errs.newPassword = t(
          'Password must be at least 8 characters and include letters, numbers, and symbols'
        )
        hasError = true
      }

      if (!passwords.confirmPassword.trim()) {
        errs.confirmPassword = t('Confirm password is required')
        hasError = true
      } else if (passwords.newPassword !== passwords.confirmPassword) {
        errs.confirmPassword = t('Confirm password must match new password')
        hasError = true
      }

      setError(errs)

      if (!hasError) {
        changePassword()
      }
    }

    const changePassword = async () => {
      setDisable(true)

      const param = {
        adminId: props.adminId || '',
        currentpassword: passwords.currentPassword,
        newpassword: passwords.newPassword,
      }

      const res = await fetchData('admin/changepassword', param)

      if (res.status == '200') {
        toastsuccessmsg(res.message)
        setDisable(false)
        props.onHide()
      } else {
        setDisable(false)
        toasterrormsg(res.message)
      }
    }

    const renderPasswordField = (label: string, name: keyof typeof passwords) => (
      <div className='fv-row mb-3 pt-1' style={{position: 'relative'}}>
        <label className='form-label fw-bolder text-dark fs-6 mb-2 required'>{t(label)}</label>
        <div style={{position: 'relative'}}>
          <input
            type={visibleFields[name] ? 'text' : 'password'}
            name={name}
            placeholder={t(label)}
            className='form-control bg-transparent'
            autoComplete='off'
            value={passwords[name]}
            onChange={handleChange}
          />
          <span
            className='cursor-pointer'
            style={{position: 'absolute', top: '25%', right: '20px'}}
            title={visibleFields[name] ? 'Hide' : 'Show'}
            onClick={() => toggleVisibility(name)}
          >
            <FontAwesomeIcon icon={visibleFields[name] ? faEyeSlash : faEye} />
          </span>
        </div>
        <label className='text-danger'>{error[name] || ''}</label>
      </div>
    )

    return (
      <Modal
        {...props}
        size='xl'
        aria-labelledby='contained-modal-title-hcenter'
        dialogClassName='maxwidth1000px'
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10'>
            <h4 className='fw-bold'>{t('Change Password')}</h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className='stepper stepper-links d-flex flex-column'>
            <div className='mx-auto mw-600px w-100 py-10'>
              {renderPasswordField('Current Password', 'currentPassword')}
              {renderPasswordField('New Password', 'newPassword')}
              {renderPasswordField('Confirm Password', 'confirmPassword')}

              <div className='d-flex pt-15 justify-content-center'>
                <button
                  type='button'
                  className='btn btn-lg btn-light-success me-3'
                  onClick={props.onHide}
                >
                  {t('Cancel')}
                </button>
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-lg btn-success monthBtn me-3'
                  onClick={validate}
                >
                  {!disable && t('Save')}
                  {disable && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      {t('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

function ViewSupportAdmin() {
  let t = Tr()
  const {menuId, menuIdDelete, menuIdEdit, menuIdAdd} = useMenuIdPermissions()

  const [showAddEditAdminPopup, setShowAddEditAdminPopup] = useState(false)
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false)
  const [adminList, setAdminList] = useState([])
  const [orgAdminList, setOrgAdminList] = useState([])
  const [adminId, setAdminId] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)

  var tmp: any = sessionStorage.getItem('customer')
  tmp = JSON.parse(tmp)

  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('Full Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.fullName != '' ? row.fullName : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.fullName),
      },
      {
        name: t('Email'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.email != '' ? row.email : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.email),
        filter: true,
      },
      {
        name: t('Mobile Number'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.mobileNumber != '' ? row.mobileNumber : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.mobileNumber),
        filter: true,
      },
      {
        name: t('Role Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.roleName != '' ? row.roleName : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.roleName),
        filter: true,
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {row.roleId != '1' ? (
              <>
                {menuIdEdit ? (
                  <button
                    className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
                    title='Edit'
                    onClick={() => {
                      setShowAddEditAdminPopup(true)
                      setAdminId(row.adminId)
                    }}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                ) : (
                  ''
                )}
                {menuIdEdit ? (
                  <button
                    className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-light-warning'
                    title='Change Password'
                    onClick={() => {
                      setShowChangePasswordPopup(true)

                      setAdminId(row.adminId)
                    }}
                  >
                    <FontAwesomeIcon icon={faKey} />
                  </button>
                ) : (
                  ''
                )}
                {menuIdDelete ? (
                  <button
                    className='btn btn-icon btn-wave waves-effect waves-light btn-sm btn-primary-light me-2'
                    title='delete'
                    onClick={() => deleteSupportAdmin(row.adminId)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button>
                ) : (
                  ''
                )}
              </>
            ) : (
              <div className='badge badge-sm  p-2 badge-danger'>{t("Not Editable")}</div>
            )}
          </>
        ),
        //   width:"140px"
      },
    ],
    [t]
  )

  const deleteSupportAdmin = async (adminId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete This Support Admin!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'), // Custom OK button text
      cancelButtonText: t('Cancel'), // Custom Cancel button text
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          var param: any = {
            typeId: String(adminId),
            type: 'admin',
          }

          const response = await fetchData('admin/deleteMasterData', param)

          if (response.status == '200') {
            toastsuccessmsg(response.message)
            adminListApiCall()
          } else {
            toasterrormsg(response.message)
          }
        } catch (error) {
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  // call admin list api
  const adminListApiCall = async () => {
    var param: any = {}
    var response: any = await fetchData('admin/adminList', param)

    if (response.status == '200') {
      setAdminList(response.data)
      setOrgAdminList(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | View Support Admin'
    adminListApiCall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Support Admin')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8 ' data-kt-user-table-toolbar='base'>
          <div className='d-flex justify-content-end col-xl-8 ' data-kt-user-table-toolbar='base'>
            {menuIdAdd ? (
              <button
                type='button'
                className='btn btn-success'
                onClick={() => setShowAddEditAdminPopup(true)}
              >
                <KTIcon iconName='plus' className='fs-2' />
                {t('Add Support Admin')}
              </button>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    )
  }

  //search function
  const adminSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setAdminList(orgAdminList)
    } else {
      var tmp: any = orgAdminList.filter(
        (item: any) =>
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase() == text.toLowerCase()) ||
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.ru_name != null &&
            item.ru_name != '' &&
            item.ru_name.toLowerCase() == text.toLowerCase()) ||
          (item.ru_name != null &&
            item.ru_name != '' &&
            item.ru_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.uz_name != null &&
            item.uz_name != '' &&
            item.uz_name.toLowerCase() == text.toLowerCase()) ||
          (item.uz_name != null &&
            item.uz_name != '' &&
            item.uz_name.toLowerCase().includes(text.toLowerCase()))
      )
      setAdminList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgAdminList.length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={adminList}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader search={searchTerm} isfoc={focus} customSearch={adminSearch} />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column mt-10 pt-20 pb-2 mb-2'>
                    <h2 className='fs-2x fw-bold'>{t('Welcome To Support Admin')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold'>
                    {t('There are no Support Admin')}
                  </p>
                  <Link
                    to='#'
                    className='btn btn-success monthBtn'
                    onClick={() => {
                      if (menuIdAdd) {
                        setShowAddEditAdminPopup(true)
                      }
                    }}
                  >
                    {t('Add Support Admin')}
                  </Link>
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showAddEditAdminPopup && (
          <AddEditAdminPopup
            show={showAddEditAdminPopup}
            onHide={() => {
              setShowAddEditAdminPopup(false)
              setAdminId(0)
                    adminListApiCall()
            }}
            adminId={adminId}
          />
        )}
        {showChangePasswordPopup && (
          <ChangePasswordPopup
            show={showChangePasswordPopup}
            onHide={() => {
              setShowChangePasswordPopup(false)
              setAdminId(0)
            }}
            adminId={adminId}
          />
        )}
      </div>
    </>
  )
}

export default ViewSupportAdmin
